import { ActionContext, ActionTree, GetterTree, MutationTree } from 'vuex';
import { ID, parseID } from '../../dndg/helpers';
import { get, post, del, ApiResult, checkResult } from '../../dndg/helpers/api';
import { State } from '../store';
import { Survey } from '../../model/api';

// Actions

type SurveyListApiResult = ApiResult<Survey[]>;

export async function listSurveys(ctx: ActionContext<State,any>) {
    const endpoint = `/_api/v1/surveys`;

    let result = await get(endpoint).then(res => res.data as SurveyListApiResult);
    let resultData = checkResult(ctx, result);
    if (resultData) {
    }
    return resultData;
}

type SurveyApiResult = ApiResult<any>;

export async function loadSurveyLanding(ctx: ActionContext<State,any>, data: { slug: string }) {
    const endpoint = `/_api/v1/surveys/${data.slug}/landing`;

    let result = await get(endpoint).then(res => res.data as SurveyApiResult);
    let resultData = checkResult(ctx, result);
    return resultData;
}

export async function loadSurvey(ctx: ActionContext<State,any>, data: { slug: string }) {
    const endpoint = `/_api/v1/surveys/${data.slug}`;

    let result = await get(endpoint).then(res => res.data as SurveyApiResult);
    let resultData = checkResult(ctx, result);
    return resultData;
}

export async function updateSurveyResult(ctx: ActionContext<State,any>, data: { slug: string, result: any }) {
    const endpoint = `/_api/v1/surveys/${data.slug}/results`;

    let result = await post(endpoint, data.result);
    return checkResult(ctx, result);
}

export async function updateSurveyResultShare(ctx: ActionContext<State,any>, data: { slug: string }) {
    const endpoint = `/_api/v1/surveys/${data.slug}/results/share`;

    let result = await post(endpoint);
    return checkResult(ctx, result);
}



// WEBPACK FOOTER //
// ./src/app/surveys/actions.ts